import axios from "axios";
import configData from "../../config/config.json";

export const login = (credential, history, callback) => async dispatch => {
  await axios.post(configData.LANDNOTIFICATION_SERVER_URL + "auth/login", credential, { withCredentials: true })
    .then((response) => {
      // We either have an error or the current user.
      if (response.data.content) {
        dispatch({ type: 'UPDATE_CURRENT_USER', currentUser: response.data.content });
        callback( { error: false } );
        history.push('/home'); // default to the home page after logging in
      } else {
        callback( { error: true, message: response.data.message });
      }
    }, (error) => {
      callback( { error: true, message: "Login Error" });
    });
};

export const logout = (history) => async dispatch => {
  await axios.get(configData.LANDNOTIFICATION_SERVER_URL + "auth/logout", { withCredentials: true })
    .then((response) => {
      history.push('/login');
      dispatch({ type: 'LOGOUT_USER'  });
    }, (error) => {
       alert("Logout Failed");
    });
};